<template>
  <sticky-header-layout>
    <template #header/>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="Name"
      >
        <template slot-scope="{ row }">
          {{ row }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="65"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import { getTrendingTopBrandList } from '../../api/trendings'

export default {
  name: 'TrendingTopBrandList',
  mixins: [useTablePaging],
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getTrendingTopBrandList()
        const topBrands = response.data
        if (Array.isArray(topBrands)) {
          this.list = topBrands
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleUpdate(row) {
      this.$router.push({ path: `/trending/top-brand-edit/${row}` })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
// .search-container {
//   display:flex;
//   .keyword-search-input {
//     width: 240px;
//   }
//   button {
//     margin: 0 5px;
//   }
// }
// .pagination-container {
//   padding: 10px 0;
// }
</style>

